<template>
  <page-view :title="false">
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="名称"
                ><a-input v-model="queryParam.descript" placeholder="名称"
              /></a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="代码"
                ><a-input v-model="queryParam.code" placeholder="代码"
              /></a-form-item>
            </a-col>
            <template v-if="advanced">
              <a-col :md="8" :sm="24">
                <a-form-item label="是否停用">
                  <a-select
                    v-model="queryParam.isHalt"
                    placeholder="请选择"
                    allowClear
                  >
                    <a-select-option value="F">正常</a-select-option>
                    <a-select-option value="T">停用</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </template>
            <a-col :md="(!advanced && 8) || 24" :sm="24">
              <span
                class="table-page-search-submitButtons"
                :style="
                  (advanced && { float: 'right', overflow: 'hidden' }) || {}
                "
              >
                <a-button type="primary" @click="$refs.table.refresh(true)"
                  >查询</a-button
                >
                <a-button class="button-margin-left" @click="rest"
                  >重置</a-button
                >
                <a-button
                  class="button-margin-left"
                  type="primary"
                  icon="plus"
                  v-hasAnyPermission="`thirdconfig:add`"
                  @click="add"
                  >新建</a-button
                >
                <a @click="toggleAdvanced" class="button-margin-left">
                  {{ advanced ? "收起" : "展开" }}
                  <a-icon :type="advanced ? 'up' : 'down'" />
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>

      <!-- 数据表格 -->
      <s-table
        ref="table"
        rowKey="id"
        :columns="columns"
        :data="loadData"
        :scroll="{ x: 2100 }"
        showPagination="auto"
      >
        <span slot="tagItem" slot-scope="text, record">
          <template>
            {{ text }}
            <a-tag class="render-tag" color="grey" v-if="record.isHalt == 'T'"
              >已停用</a-tag
            >
          </template>
        </span>
        <span slot="action" slot-scope="text, record">
          <template>
            <a
              class="a-action"
              @click="action(record, 'edit')"
              v-hasAnyPermission="`thirdconfig:add`"
              >编辑</a
            >
            <a-popconfirm
              title="确认删除?"
              @confirm="action(record, 'del')"
              okText="确认"
              cancelText="取消"
              v-hasAnyPermission="`thirdconfig:delete`"
              ><a class="a-action">删除</a></a-popconfirm
            >
          </template>
        </span>
      </s-table>
    </a-card>
    <third-config-info
      ref="optionInfo"
      @success="$refs.table.refresh(true)"
    ></third-config-info>
  </page-view>
</template>

<script>
import moment from "moment";
import { STable } from "@/components";
import { PageView } from "@/layouts";
import ThirdConfigInfo from "./ThirdConfigInfo.vue";

export default {
  name: "ThirdConfigList",
  components: {
    STable,
    PageView,
    ThirdConfigInfo
  },
  data() {
    return {
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {},
      // 表头
      columns: [
        {
          title: "代码",
          dataIndex: "code",
          scopedSlots: { customRender: "tagItem" },
          fixed: "left"
        },
        {
          title: "名称",
          dataIndex: "descript",
          fixed: "left"
        },
        {
          title: "类型",
          dataIndex: "type",
          fixed: "left"
        },
        {
          title: "应用id",
          dataIndex: "appId",
          fixed: "left"
        },
        {
          title: "应用key",
          dataIndex: "appKey",
          width: 170
        },
        {
          title: "应用秘钥",
          dataIndex: "appSecret",
          width: 200,
          ellipsis: true
        },
        {
          title: "应用主秘钥",
          dataIndex: "masterSecret",
		  ellipsis: true
        },
        {
          title: "签名",
          dataIndex: "signature"
        },
        {
          title: "服务地址",
          dataIndex: "host"
        },
        {
          title: "端口号",
          dataIndex: "port"
        },
        {
          title: "备注",
          dataIndex: "remark"
        },
        {
          title: "操作人",
          dataIndex: "modifyUser"
        },
        {
          title: "更新时间",
          dataIndex: "modifyDatetime",
          width: 120
        },
        {
          title: "操作",
          dataIndex: "action",
          align: "left",
          fixed: "right",
          width: 120,
          scopedSlots: { customRender: "action" }
        }
      ],
      //加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return this.$http.systemBksApi
          .pageThirdConfig(Object.assign(parameter, this.queryParam))
          .then(res => {
            return res.resultObject;
          });
      }
    };
  },
  created() {},
  methods: {
    /**
     * 操作
     * @param {Object} record
     * @param {Object} type
     */
    action(record, type) {
      if (type == "edit") {
        this.$refs.optionInfo.showModal(type, Object.assign({}, record));
      } else if (type == "del") {
        this.$http.systemBksApi
          .deleteThirdConfigById({ id: record.id })
          .then(res => {
            if (res.result == 0) {
              this.$refs.table.refresh(true);
              this.$message.success(res.msg);
            }
          });
      }
    },
    add() {
      this.$refs.optionInfo.showModal("add", null);
    },
    /**
     * 展开/收起查询条件
     */
    toggleAdvanced() {
      this.advanced = !this.advanced;
    },
    rest() {
      this.queryParam = {
        sort: "list_order"
      };
    }
  }
};
</script>
